import Leads from './Leads';

export default Leads;
